/** Base path for the ConvoAI Spaces REST API. */
export const SPACES_API_PATH = '/gateway/api/assist/rovo/v1/spaces';

/** Maximum number of characters allowed for a space name. */
export const SPACE_NAME_MAX_LENGTH = 100;

/** Maximum number of characters allowed for a space description (About field). */
export const SPACE_ABOUT_MAX_LENGTH = 500;
